function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.05715 6.04C1.56715 6.55 2.37716 6.6 2.92716 6.14C7.59716 2.3 14.3772 2.3 19.0572 6.13C19.6172 6.59 20.4372 6.55 20.9472 6.04C21.5372 5.45 21.4972 4.47 20.8472 3.94C15.1372 -0.73 6.87715 -0.73 1.15715 3.94C0.507155 4.46 0.457155 5.44 1.05715 6.04ZM8.81715 13.8L10.2872 15.27C10.6772 15.66 11.3072 15.66 11.6972 15.27L13.1672 13.8C13.6372 13.33 13.5372 12.52 12.9372 12.21C11.7172 11.58 10.2572 11.58 9.02715 12.21C8.45715 12.52 8.34715 13.33 8.81715 13.8ZM6.91716 10.2C6.34716 10.61 5.57716 10.56 5.08715 10.07C4.47715 9.46 4.51715 8.45 5.20715 7.95C8.65716 5.46 13.3472 5.46 16.7872 7.95C17.4772 8.44 17.5172 9.46 16.9172 10.06L16.9072 10.07C16.4172 10.56 15.6472 10.6 15.0772 10.2C12.6372 8.47 9.35715 8.47 6.91716 10.2Z",
  fill: "#1BB021"
});

function SvgNetworkGood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkGood);
export default __webpack_public_path__ + "static/media/network-good.5cbf42aa.svg";
export { ForwardRef as ReactComponent };